import { useEffect, useState } from 'react';
import { alreadyPrompted, ensureFreshClient, markPrompted } from '@integrations/watchpod/browser';
import { UpdateAvailableModal } from '@integrations/watchpod/react';
import { api } from '../lib/api';
import type { UpdatesView } from '../lib/api';
import { browserOptions, STORAGE_PREFIX, updateActions, updatesUi } from '../lib/integrations';

// I due momenti degli aggiornamenti che non devono sfuggire, montati una volta sola:
// - la pagina è più vecchia del server (una scheda rimasta aperta durante un aggiornamento):
//   si ricarica, anche quando la scheda torna in primo piano;
// - c'è una release più recente: si propone una volta per versione, «Posticipa» tace finché
//   non ne esce una più nuova.
export function UpdatesGate({ enabled }: { enabled: boolean }) {
  const [overview, setOverview] = useState<UpdatesView | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const check = () => void ensureFreshClient(browserOptions, __APP_VERSION__);
    check();
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const ask = () =>
      api
        .updates()
        .then((next) => alive && setOverview(next))
        // WatchPOD irraggiungibile o spento: non deve mai disturbare chi lavora
        .catch(() => undefined);
    void ask();
    const timer = window.setInterval(ask, 15 * 60_000);
    return () => {
      alive = false;
      window.clearInterval(timer);
    };
  }, [enabled]);

  if (!overview?.updateAvailable || !overview.latest) return null;
  if (dismissed || overview.snoozed || alreadyPrompted(overview.latest, STORAGE_PREFIX))
    return null;

  return (
    <UpdateAvailableModal
      ui={updatesUi}
      offer={{ version: overview.latest, notes: overview.notes, releasedAt: overview.releasedAt }}
      actions={updateActions}
      onClose={() => {
        markPrompted(overview.latest, STORAGE_PREFIX);
        setDismissed(true);
      }}
      onHandled={() => setDismissed(true)}
      warning="Si riavvia solo PopTown, per circa un minuto: i lavori in corso riprendono da soli."
    />
  );
}
